export const ADD_FAVORITE = 'ADD_FAVORITE'

/**
 * Add a route to the favorites.
 * @param {number} routeId
 */
export const addFavorite = routeId => ({
    type: ADD_FAVORITE,
    routeId,
})

export const REMOVE_FAVORITE = 'REMOVE_FAVORITE'

/**
 * Remove a route from the favorites.
 * @param {number} routeId
 */
export const removeFavorite = routeId => ({
    type: REMOVE_FAVORITE,
    routeId,
})

export const UPDATE_ROUTE = 'UPDATE_ROUTE'

/**
 * Update a route with detailed data.
 * @param {import("../../entities").Route} route
 */
export const updateRoute = route => ({
    type: UPDATE_ROUTE,
    route,
})
